<app-nav-header></app-nav-header>
<div class="main-sidenav-container {{isNavSidebarExpanded ? '' : 'sidebar-collapsed'}}">
    <app-nav-sidebar class="nav-sidebar"></app-nav-sidebar>
    <div class="nav-layout-content">
        <div class="nav-client-picker-container" [ngStyle]="clientPickerCtrStyle">
            <app-nav-env-picker *ngIf="!useIframeStyling"></app-nav-env-picker>
            <app-nav-client-picker class="nav-layout-client-picker"></app-nav-client-picker>
            <app-nav-new-tab *ngIf="!useIframeStyling"></app-nav-new-tab>
        </div>
        <div class="nav-main-content">
            <app-nav-env-message></app-nav-env-message>
            <app-nav-phone-call-banner *ngIf="showPhoneCallBanner | async" class="nav-layout-phone-call-banner"></app-nav-phone-call-banner>
            <router-outlet *ngIf="currentCaseName || !requiresCaseSelection"></router-outlet>
            <app-no-case-selected-overlay *ngIf="!currentCaseName && requiresCaseSelection"></app-no-case-selected-overlay>
        </div>
    </div>
</div>
